"use client";

import { AlertTriangle, LockKeyhole, SearchX } from "lucide-react";
import { useTranslations } from "next-intl";

import { Button } from "@/components/ui/button";
import type { WorkspaceStatus } from "./workspace-context";

const icons = {
  unauthorized: LockKeyhole,
  forbidden: LockKeyhole,
  notFound: SearchX,
  unavailable: AlertTriangle,
};

export function WorkspaceState({
  status,
  reload,
}: {
  status: Exclude<WorkspaceStatus, "ready">;
  reload: () => void;
}) {
  const t = useTranslations("workspace.states");
  if (status === "loading")
    return (
      <main className="grid min-h-dvh place-items-center">
        <span role="status" className="text-sm text-muted-foreground">
          {t("loading")}
        </span>
      </main>
    );
  const Icon = icons[status];
  return (
    <main className="grid min-h-dvh place-items-center bg-muted/40 p-5">
      <section
        role="alert"
        className="w-full max-w-md rounded-lg border bg-card p-7 text-center shadow-xs"
      >
        <Icon
          className="mx-auto size-7 text-muted-foreground"
          aria-hidden="true"
        />
        <h1 className="mt-4 text-xl font-semibold">{t(`${status}.title`)}</h1>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">
          {t(`${status}.description`)}
        </p>
        {status === "unauthorized" ? (
          <Button asChild className="mt-5">
            <a href="/oauth/login?returnTo=/">{t("unauthorized.action")}</a>
          </Button>
        ) : (
          <Button variant="outline" className="mt-5" onClick={reload}>
            {t("retry")}
          </Button>
        )}
      </section>
    </main>
  );
}
